/**
 * variant-legend-value.js
 *
 * Keeps the "<option name>: <value>" label (rendered in the variant option
 * legend) in sync with the shopper's current selection for options rendered as
 * color swatches or variant boxes. Uses a single delegated listener so it also
 * works for product forms injected later (e.g. quick view).
 */
(function () {
	function updateSwatchStates(fieldset) {
		if (!fieldset) return

		fieldset.querySelectorAll('.swatch__button').forEach((button) => {
			button.classList.remove('is-selected')
		})

		const checked = fieldset.querySelector('input[data-single-option-selector]:checked')
		checked?.closest('.swatch__button')?.classList.add('is-selected')
	}

	function syncFieldsetInputs(fieldset, optionValue) {
		if (!fieldset || optionValue == null) return

		const normalizedValue = String(optionValue).trim()

		fieldset.querySelectorAll('input[data-single-option-selector]').forEach((input) => {
			input.checked = input.value.trim() === normalizedValue
		})
	}

	function updateSizeGenderSelected(fieldset) {
		const sizeGenderTabs = fieldset?.querySelector('size-gender-tabs')
		if (!sizeGenderTabs || typeof sizeGenderTabs.updateSelectedSize !== 'function') return

		sizeGenderTabs.updateSelectedSize()
	}

	function updateFieldset(fieldset) {
		if (!fieldset) return

		const valueEl = fieldset.querySelector('[data-selected-value]')
		const checked = fieldset.querySelector('input[data-single-option-selector]:checked')

		if (valueEl && checked) {
			valueEl.textContent = checked.value
		}

		updateSwatchStates(fieldset)
		updateSizeGenderSelected(fieldset)
	}

	function syncVariantSelects(productInfo, variant) {
		if (!productInfo || !variant?.options) return

		const variantSelects = productInfo.querySelector('variant-selects')
		if (!variantSelects) return

		const fieldsets = variantSelects.querySelectorAll('fieldset')

		variant.options.forEach((optionValue, index) => {
			const fieldset = fieldsets[index]
			if (!fieldset) return

			syncFieldsetInputs(fieldset, optionValue)
			updateFieldset(fieldset)
		})
	}

	function removeStaleVariantSelects(productInfo) {
		if (!productInfo) return

		const variantSelects = productInfo.querySelectorAll('variant-selects')

		if (variantSelects.length <= 1) return

		variantSelects.forEach((variantSelect) => {
			if (variantSelect.style.display === 'none') {
				variantSelect.remove()
			}
		})
	}

	function getProductInfoForSection(sectionId) {
		return Array.from(document.querySelectorAll('product-info')).find((productInfo) => {
			const id = productInfo.dataset.originalSection || productInfo.dataset.section
			return id === sectionId
		})
	}

	function handleSwatchInteraction(event) {
		const swatchButton = event.target.closest('.selector-wrapper--swatches .swatch__button')
		if (!swatchButton) return

		const fieldset = swatchButton.closest('.radio__fieldset')
		if (!fieldset) return

		queueMicrotask(() => updateFieldset(fieldset))
	}

	document.addEventListener('click', handleSwatchInteraction)
	document.addEventListener('change', function (event) {
		const input = event.target
		if (!input || typeof input.matches !== 'function') return
		if (!input.matches('input[data-single-option-selector]')) return

		updateFieldset(input.closest('.radio__fieldset'))
	})

	if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
		subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function ({ data }) {
			if (!data?.variant) return

			const productInfo = getProductInfoForSection(data.sectionId)
			if (!productInfo) return

			removeStaleVariantSelects(productInfo)

			requestAnimationFrame(() => {
				syncVariantSelects(productInfo, data.variant)
			})
		})
	}
})()
